(function($){
        
    $(document).ready(function() {

        setTimeout(function(){
            $(".navbar-brand img").css("display","inline-block");
        },10);

            $('#challengeEntryModal').on('show.bs.modal', function (event) {
                
                var button = $(event.relatedTarget);
                var video = button.data('ceVideo');
                var image = button.data('ceImage');
                var title = button.data('ceTitle');
                var excerpt = button.data('ceExcerpt');
                var author = button.data('ceAuthor');
               
                var cardImageElement = $(this).find('.card-image');
                var cardVideoElement = $(this).find('.card-video');
                var cardVideoWrapperElement = $(this).find('.video-wrapper');
                var cardTitleElement = $(this).find('.card-title');
                var cardExcerptElement = $(this).find('.card-excerpt');
                var cardAuthorElement = $(this).find('.card-author');

                cardVideoWrapperElement.addClass("d-none");
                cardVideoElement.attr("src",'');
                cardImageElement.addClass("d-none");
                
                if(video){
                    cardVideoWrapperElement.removeClass("d-none");
                    cardVideoElement.attr("src",video);                    
                }else if(image){
                    cardImageElement.removeClass("d-none");
                    cardImageElement.html(atob(image));
                }
                cardTitleElement.text(title);
                cardExcerptElement.text(excerpt);
                cardAuthorElement.text(author);
            });

            $('#challengeEntryModal').on('hidden.bs.modal', function(){
                $(this).find('video')[0].pause();
            });

    });

})(jQuery);